import {
    makeStyles,
    createStyles,
    Theme,
    useTheme,
} from '@material-ui/core/styles'
import * as colors from '~/constants/colors'
import { TYPOGRAPHY } from '~/constants/typography'

export default makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            width: '80%',
            margin: '0 auto',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
            [theme.breakpoints.down('xs')]: {
                width: '100%',
            },
        },
        item: {
            paddingBottom: theme.spacing(8),
            [theme.breakpoints.down('xs')]: {
                paddingBottom: theme.spacing(5),
            },
            '&:nth-child(odd)': {
                paddingRight: 72,
                [theme.breakpoints.down('md')]: {
                    paddingRight: 20,
                },
                [theme.breakpoints.down('sm')]: {
                    paddingRight: 0,
                },
            },
            '&:nth-child(even)': {
                paddingLeft: 72,
                [theme.breakpoints.down('md')]: {
                    paddingLeft: 20,
                },
                [theme.breakpoints.down('sm')]: {
                    paddingLeft: 0,
                },
            },
        },
        icon: {},
        iconWrapper: {
            width: 54,
            height: 54,
            margin: 21,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                width: 68,
                height: 68,
                margin: 14,
            },
        },
        title: {
            marginBottom: theme.spacing(1),
            color: colors.GREY_COLOR.Grey1,
            [theme.breakpoints.down('xs')]: {
                ...TYPOGRAPHY.h6,
            },
        },
        description: {
            color: colors.GREY_COLOR.Grey1,
            [theme.breakpoints.down('xs')]: {
                lineHeight: 1.75,
                letterSpacing: 0.25,
            },
        },
    })
)
